export default __webpack_public_path__ + "static/media/filters.73b692af.png";